import React from 'react';
import { ListChecksIcon, CalendarDaysIcon, BrainIcon, LeafIcon } from 'lucide-react';
import { benefits } from '../data/offer';
const icons = {
  plan: ListChecksIcon,
  calendar: CalendarDaysIcon,
  brain: BrainIcon,
  leaf: LeafIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="adentro-titulo" className="w-full bg-forest-900 text-cream-100" data-id="element-17" data-mp="3np1gs0k8yxel">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-20 lg:py-28" data-id="element-18" data-mp="38sadhg7gd1jp">
        <div className="max-w-2xl" data-id="element-19" data-mp="38udbonire0zi">
          <h2 id="adentro-titulo" className="font-display text-2xl font-extrabold leading-tight tracking-tight text-cream-50 sm:text-4xl" data-id="element-20" data-mp="3drdi4zjit5r5">
            ¿Qué vas a encontrar adentro?
          </h2>
          <p className="mt-3 text-[15px] text-moss-200 sm:mt-4 sm:text-lg" data-id="element-21" data-mp="34qytbq7cl8iw">
            Todo lo que necesitás para empezar a transformar tu rutina en 21 días.
          </p>
        </div>

        {/* Mobile: carrusel deslizable · Desktop: grilla */}
        <ul className="-mx-5 mt-7 flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:mx-0 sm:mt-12 sm:grid sm:snap-none sm:grid-cols-2 sm:gap-x-14 sm:gap-y-10 sm:overflow-visible sm:px-0 lg:mt-16" data-id="element-22" data-mp="2bexlj83c2wvb">
          {benefits.map(benefit => {
          const Icon = icons[benefit.icon];
          return <li key={benefit.title} className="flex w-[78%] shrink-0 snap-center flex-col rounded-xl border border-forest-700 bg-forest-800 p-5 sm:w-auto sm:shrink sm:rounded-none sm:border-0 sm:border-t sm:border-forest-700 sm:bg-transparent sm:p-0 sm:pt-6" data-id="element-23" data-mp="2g88hufairv8z">
                <Icon className="h-5 w-5 text-moss-400 sm:h-6 sm:w-6" aria-hidden="true" data-id="element-24" data-mp="1xfed0e6m1jih" />
                <h3 className="mt-3 font-display text-base font-bold leading-snug text-cream-50 sm:mt-4 sm:text-xl" data-id="element-25" data-mp="1xhr4pj26788q">
                  {benefit.title}
                </h3>
                <div className="mt-2 space-y-2 text-sm leading-relaxed text-moss-200 sm:mt-3 sm:space-y-3 sm:text-[15px]" data-id="element-26" data-mp="38u1lss7jxfxc">
                  {benefit.paragraphs.map(paragraph => <p key={paragraph} data-id="element-27" data-mp="3kvjfzx8kggqk">{paragraph}</p>)}
                </div>
              </li>;
        })}
        </ul>
        <p className="mt-2 text-xs text-moss-400 sm:hidden" data-id="element-28" data-mp="3uv0k4a866mkf">Deslizá para ver los 4 →</p>
      </div>
    </section>;
}